
export interface ProjectData {
  projectName: string; // New: Project Name/Code
  location: string;
  scale: string; // e.g., 3000sqm or 100 units
  standardFloorArea?: string; // Optional: Standard floor area size
  ceilingHeight: string;
  utilitiesType: 'commercial' | 'residential'; // 商水商电 vs 民水民电
  propertyFee: string;
  openingDate: string;
  marketDataFile?: File[] | null; // Changed to allow multiple files
  customInfo?: string; // Optional user provided context (e.g. known competitors)
  designImageBase64?: string; // Store the uploaded floor plan image for the report
}

export interface FinancialParams {
  capexPerSqm: string; // 改造单方成本
  leaseModel: 'fixed' | 'ratio' | 'light_asset'; // 底租模式: 固定 | 分成 | 轻资产委托
  leaseUnitValue: string; // 数值：若是fixed则为元/平/月，若是ratio则为%
  rentFreePeriod: string; // 免租期 (月)
  leaseTerm: string; // 租期 (年)
  rentEscalation: string; // 底租递增条款
  revenueGrowthRate: string; // 营收增长率假设 (新增)
  // New fields for Light Asset
  revenueShare?: string; // 营收分成 X%
  noiShare?: string;     // NOI分成 Y%
  // New field for custom info
  customFinancials?: string; // 补充的财务/税务/融资信息
}

export interface StepResult {
  stepId: number;
  title: string;
  content: string; // Markdown content returned by AI
  timestamp: number;
}

export enum StepStage {
  INIT = 0,
  MARKET_INTEL = 1,     // Step 1
  PERSONA_GRAVITY = 2,  // Step 2
  PRICING_GAME = 3,     // Step 3
  PRODUCT_STRATEGY = 4, // Step 4
  DESIGN_BRIEF = 5,     // Step 5
  DESIGN_VALIDATION = 6, // Step 5.5 (Upload)
  FINANCIAL_MODEL = 7,  // Step 6
  FINAL_REPORT = 8      // Step 7
}

export interface ChatMessage {
  role: 'user' | 'model';
  text: string;
  image?: string; // base64 string
}
